module.exports = __webpack_public_path__ + "static/media/registration2.3c069a18.jpg";